import { projectFundingRequirementKey } from './ProjectFundingRequirement';
import { useTranslation } from 'react-i18next';
import type { ProjectFundingStatus } from '../types';

export function ProjectFundingAccountCoverage({ funding }: { funding: ProjectFundingStatus }) {
  const { t, i18n } = useTranslation();
  const account = funding.account;
  if (!account || account.remainingMilestoneCount === 0) return null;
  const money = (ore: number) => new Intl.NumberFormat(i18n.language === 'en' ? 'en-GB' : 'sv-SE', {
    style: 'currency', currency: 'SEK', minimumFractionDigits: 0, maximumFractionDigits: 2
  }).format(ore / 100);
  const selected = account.milestoneIds.map(id => funding.milestones.find(stage => stage.milestoneId === id)).filter(Boolean);
  const stageLabels = selected.map(stage => t(funding.contracts.length > 1 ? 'projectFunding.card.stageWithContract' : 'projectFunding.card.stage', {
    number: stage!.milestoneNumber, contract: stage!.contractNumber
  })).join(' + ');
  const stages = stageLabels.charAt(0).toLocaleUpperCase(i18n.language) + stageLabels.slice(1);
  const percent = account.requiredAmountOre > 0 ? Math.min(100, Math.max(0, account.fundingBalanceOre / account.requiredAmountOre * 100)) : 100;

  return <div className="mt-3" data-testid="project-funding-coverage">
    {account.fulfilled && <p className="fw-semibold mb-2">{selected.length === account.milestoneIds.length
      ? t('projectFunding.account.stagesFunded', { count: selected.length, stages })
      : t('projectFunding.account.fulfilled')}</p>}
    <div className="d-flex flex-wrap justify-content-between gap-2 text-explain mb-2">
      <span>{t('projectFunding.account.availableBalance', { amount: money(account.fundingBalanceOre) })}</span>
      <span>{stages ? t('projectFunding.account.stageRequirement', { stages, amount: money(account.requiredAmountOre) })
        : t(projectFundingRequirementKey(account), { count: account.startedMilestoneCount || account.milestoneIds.length, amount: money(account.requiredAmountOre) })}</span>
    </div>
    <div className="progress" role="progressbar" aria-label={t('projectFunding.account.coverageProgress')}
      aria-valuenow={Math.round(percent)} aria-valuemin={0} aria-valuemax={100}>
      <div className={`progress-bar ${account.fulfilled ? 'bg-success' : 'bg-warning'}`} style={{ width: `${percent}%` }} />
    </div>
    <p className="text-explain mt-2 mb-0">{t('projectFunding.account.requirementPurpose')}</p>
  </div>;
}
